import Vue from 'vue'
import Store from '@/store'
import Router from 'vue-router'
import auth from '@/routes/auth'
import dashboard from '@/routes/dashboard'
import estado from '@/routes/estado'
import regiao from '@/routes/regiao'
import cidade from '@/routes/cidade'
import usuario from '@/routes/usuario'
import tecnico from '@/routes/tecnico'
import cliente from '@/routes/cliente'
import industria from '@/routes/industria'
import email from '@/routes/email'
import telefone from '@/routes/telefone'
import clienteIndustria from '@/routes/cliente.industria'
import clienteResponsavel from '@/routes/cliente.responsavel'
import visita from '@/routes/visita'
import balancete from '@/routes/balancete'
import laudo from '@/routes/laudo'
import documento from '@/routes/documento'
import relatorio from '@/routes/relatorio'
import relatorioRegiao from '@/routes/relatorio.regiao'
import relatorioCidade from '@/routes/relatorio.cidade'
import relatorioProducao from '@/routes/relatorio.producao'
import relatorioTecnico from '@/routes/relatorio.tecnico'
import relatorioIndustria from '@/routes/relatorio.industria'
import relatorioContrato from '@/routes/relatorio.contrato'
import pendencias from '@/routes/pendencia'
import controle from '@/routes/controle'

Vue.use(Router)

let routes = new Router({
  mode: 'history',
  base: '/',
  scrollBehavior () {
    window.scrollTo(0, 0)
  },
  routes: [
    ...auth,
    ...dashboard,
    ...estado,
    ...regiao,
    ...cidade,
    ...usuario,
    ...tecnico,
    ...cliente,
    ...industria,
    ...telefone,
    ...email,
    ...clienteIndustria,
    ...clienteResponsavel,
    ...visita,
    ...balancete,
    ...laudo,
    ...documento,
    ...relatorio,
    ...relatorioRegiao,
    ...relatorioCidade,
    ...relatorioProducao,
    ...relatorioTecnico,
    ...relatorioIndustria,
    ...relatorioContrato,
    ...pendencias,
    ...controle
  ]
})

routes.beforeEach(async (to, from, next) => {
  if (to.meta.requireAuth && !Store.getters.isLogged) {
    return next({
      name: 'login'
    })
  }
  if (!to.meta.requireAuth && Store.getters.isLogged) {
    return next({
      name: 'dashboard-index'
    })
  }
  next()
})

routes.beforeResolve(async (to, from, next) => {
  if (Store.getters.isLogged) {
    await Store.dispatch('getUserAtual')
  }
  next()
})

export default routes
